import {errorToJSON} from 'src/shared/utils/errorToJSON';
import {formatDateForApi, formatDateForDaySelectText, formatTime} from 'src/shared/utils/date';
import {fetchWithToken} from 'src/shared/api';
import {LOAD_USER_SUCCESS} from 'src/shared/user/actions';
import {AUTH} from 'src/shared/auth/actions';
import {waitUntil} from 'src/shared/events';
import {setTimeslot} from './app';

export const LOAD_TIMESLOTS_START = 'LOAD_TIMESLOTS_START';
export const LOAD_TIMESLOTS_SUCCESS = 'LOAD_TIMESLOTS_SUCCESS';
export const LOAD_TIMESLOTS_ERROR = 'LOAD_TIMESLOTS_ERROR';
export const LOAD_TIMESLOTS_COMPELTE = 'LOAD_TIMESLOTS_COMPLETE';

const loadTimeslotsStart = () => ({
  type: LOAD_TIMESLOTS_START,
});

const loadTimeslotsSuccess = timeslots => ({
  type: LOAD_TIMESLOTS_SUCCESS,
  value: {timeslots},
});

const loadTimeslotsError = error => ({
  type: LOAD_TIMESLOTS_ERROR,
  value: {error: errorToJSON(error)},
});

const loadTimeslotsComplete = () => ({
  type: LOAD_TIMESLOTS_COMPELTE,
});

const normalizeTimeSlotData = slots => {
  const availableTimes = slots.availableTimesFormatted.reduce((obj, key) => {
    const slot = new Date(key['start']);
    const endTime = new Date(key['end']); // new field
    const date = formatDateForDaySelectText(slot);
    if (!obj[date]) {
      obj[date] = {
        text: date,
        date: slot,
        times: [],
      };
    }
    obj[date].times.push({
      text: `${formatTime(slot)} - ${formatTime(endTime)}`,
      value: formatDateForApi(slot),
      isoFormat: key['start'],
    });
    return obj;
  }, {});

  const timeSlots = Object.keys(availableTimes)
    .map(d => availableTimes[d])
    .sort((a, b) => a.date.getTime() - b.date.getTime());
  // add "Next Available" in today's timeslot list if isAsapEnabled is true
  if (slots.isAsapEnabled) {
    const waitTime = parseInt(slots.estimatedWaitTimeMins || 0, 10);
    const today = new Date();
    const nextAvailableSlot = {
      text: `Next Available (Est. wait: ${waitTime > 30 ? '>30' : waitTime || '0'} ${waitTime === 1 ? 'min' : 'mins'})`,
      value: 'IMMEDIATE',
    };
    if (timeSlots.length > 0) {
      timeSlots[0].text.includes('Today') && timeSlots[0].times.unshift(nextAvailableSlot);
    } else {
      timeSlots.push(
        {
          text: formatDateForDaySelectText(today),
          date: today,
          times: [nextAvailableSlot,
          ],
        }
      );
    }
  }
  return timeSlots;
};

export const loadTimeslots = intent => async (dispatch, getState) => {
  dispatch(loadTimeslotsStart());
  await waitUntil([AUTH, LOAD_USER_SUCCESS]);
  const {
    auth: {token},
  } = getState();

  const url = `${getState().config.urls.middleware}/scheduled-callbacks/available-slots/?intent=${intent}`;
  try {
    const response = await fetchWithToken(url, token);
    if (response.ok) {
      const json = await response.json();

      dispatch(loadTimeslotsSuccess(normalizeTimeSlotData(json)));
      if (json.isAsapEnabled && getState()?.app?.timeslots[0]?.text?.includes('Today')) {
        dispatch(setTimeslot('IMMEDIATE'));
      }
    } else {
      dispatch(loadTimeslotsError(new Error(response.status)));
    }
  } catch (error) {
    dispatch(loadTimeslotsError(error));
  } finally {
    dispatch(loadTimeslotsComplete());
  }
};
